<template>
  <v-dialog
    v-model="isDialogOpen"
    persistent
    max-width="640">
    <v-card>
        <v-card-title class="title-form"> Cambiar contraseña </v-card-title>
        <v-card-text>
          <div class="container-form">

            <v-text-field
              label="Nombre"
              placeholder="Nombre completo"
              v-model="collaborator.name"
              color="#222222"
              disabled="true"
              variant="underlined"
              type="text"/>

            <v-text-field
                label="Nueva contraseña"
                placeholder="Nueva contraseña"
                v-model="collaborator.password"
                color="#222222"
                variant="underlined"
                :type="showedPassword ? 'text' : 'password'"
                :rules="rules.required">
              <template v-slot:prepend-inner>
                <v-icon color="#222222" icon="mdi-lock-outline" size="small"/>
              </template>
              <template v-slot:append-inner>
                <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPassword" v-on:click="showedPassword = !showedPassword"/>
                <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPassword" v-on:click="showedPassword = !showedPassword"/>
              </template>
            </v-text-field>

            <v-text-field
                label="Repetir contraseña"
                placeholder="Repetir contraseña"
                v-model="copyPass"
                color="#222222"
                variant="underlined"
                :type="showedPassword ? 'text' : 'password'"
                :rules="rules.confirmPassword">
              <template v-slot:prepend-inner>
                <v-icon color="#222222" icon="mdi-lock-outline" size="small"/>
              </template>
              <template v-slot:append-inner>
                <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPassword" v-on:click="showedPassword = !showedPassword"/>
                <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPassword" v-on:click="showedPassword = !showedPassword"/>
              </template>
            </v-text-field>

          </div>
        </v-card-text>
        <v-card-actions>
        <v-btn
          class="btn-cancel-form"
          color="#6E6E6E"
            variant="text"
            rounded="xl"
            @click="isDialogOpen = false">
            Cancelar
        </v-btn>

        <v-btn
            class="btn-action-form"
            rounded="xl"
            color="#FFFFFF"
            :loading="isSavingData"
            :disabled="disableBtn()"
            @click="actionBtn">
            Guardar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import colaboratorsApi from '@/api/collaboratorsApi'
export default {
  name: 'CommerciaVueChangePass',
  emits: ['refreshList'],
  data () {
    return {
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      showedPassword: false,
      copyPass: '',
      collaborator: {
        name: null,
        password: null,
        _id: null,
        updated_at: null
      },
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ],
        confirmPassword: [
          v => !!v || 'Campo requerido.',
          v => v === this.collaborator.password || 'Las contraseñas no coinciden.'
        ]
      }
    }
  },

  methods: {
    edit (collaborator) {
      this.isDialogOpen = true
      this.isEdit = true
      this.collaborator = structuredClone(collaborator)
      this.collaborator.role = this.collaborator.role.description
      this.collaborator.terminal = this.collaborator.terminal._id
      this.collaborator.password = ''
    },
    disableBtn () {
      return (Object.values(this.collaborator).some(value => value === null || value === '') ||
      this.collaborator.password !== this.copyPass)
    },
    async actionBtn () {
      if (await colaboratorsApi.paswword(this.collaborator)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
